// pages/Services.js
import React, { useEffect } from "react";
import Header from "../components/home/Header";
import AboutCover from "../components/aboutus/AboutCover";
import AboutCEO from "../components/aboutus/AboutCEO";
import LetsGetPersonal from "../components/aboutus/LetsGetPersonal";
import Testimonials from "../components/home/Testimonials";
import CallToActionSection from "../components/aboutus/CallToActionSection";
import Footer from "../components/home/Footer";

function AboutUsPage() {
  return (
    <div>
      <Header />
      <AboutCover />
      <AboutCEO />
      <LetsGetPersonal />
      <Testimonials />
      <CallToActionSection />
      <Footer />
    </div>
  );
}

export default AboutUsPage;
